import React from 'react';
import PropTypes from 'prop-types';
import classes from '../addScripts.module.scss';
import InputField from '../../../../_common/Form/TextFields/InputField';
import Checkbox from '../../../../_common/Form/Checkbox/Checkbox';
import utils from '../../../../../utils/utils';

const OTC = ({
  OTCInfo: {
    homeCare, hcHome, hcPhone,
  },
  setOTC,
}) => (
  <div className={classes.copay_assistance_wrapper}>
    <h4>OTC</h4>

    <Checkbox
      label="OTC"
      checked={homeCare}
      onChange={(check) => setOTC('homeCare', check)}
    />

    <div>
      <InputField
        wrapperClassName={classes.network_pay}
        label="Home"
        value={hcHome}
        onChange={(value) => setOTC('hcHome', value)}
      />

      <InputField
        wrapperClassName={classes.network_pay}
        label="Phone"
        value={hcPhone}
        onChange={(value) => setOTC('hcPhone', value)}
        onKeyPress={(e) => utils.keyPressPhoneNumber(e)}
        onPaste={(e) => utils.keyPressPhoneNumber(e, true)}
      />
    </div>
  </div>
);

OTC.propTypes = {
  OTCInfo: PropTypes.object.isRequired,
  setOTC: PropTypes.func.isRequired,
};

export default OTC;
